import PropTypes from 'prop-types';
import Button from 'uikit/Button/Button';
import Loader from 'components/Loader';
import './ConfirmationModal.scss';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  title,
  description,
  cancelButtonText = 'Cancel',
  confirmButtonText = 'Confirm',
  type = 'confirm', // 'confirm' or 'delete'
  showLoader = true,
  additionalContent = null
}) => {
  if (!isOpen) return null;

  const handleCancel = () => {
    onClose();
  };

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
    <div className='confirmation-modal__overlay' onClick={handleCancel}>
      <div className={`confirmation-modal confirmation-modal--${type}`} onClick={(e) => e.stopPropagation()}>
        <div className='confirmation-modal__content'>
          <div className='confirmation-modal__text'>
            <h2 className='confirmation-modal__title'>{title}</h2>
            <p className='confirmation-modal__description'>
              {description}
              {additionalContent}
            </p>
          </div>

          <div className='confirmation-modal__actions'>
            <Button
              type='outline'
              size='large'
              onClick={handleCancel}
              isDisabled={isLoading}
              className={type === 'delete' ? 'cancel-delete' : ''}
            >
              {cancelButtonText}
            </Button>
            <Button
              type={type === 'delete' ? 'danger' : 'primary'}
              size='large'
              onClick={handleConfirm}
              isDisabled={isLoading}
            >
              {isLoading && showLoader ? <Loader /> : confirmButtonText}
            </Button>
          </div>
        </div>
      </div>
    </div>
    /* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
  );
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  cancelButtonText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  type: PropTypes.oneOf(['confirm', 'delete']),
  showLoader: PropTypes.bool,
  additionalContent: PropTypes.node
};

export default ConfirmationModal;
